/**
* Programs Tabs JS
* -----------------------------------------------------------------------------
*
* All the JS for the Programs Tabs component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'programs-tabs',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.programs-tabs' ).each( function( key, val ) {
        let maxHeight = 0;
        $( this ).find( '.program-info' ).each( function( programKey, programVal ) {
          if ( $( this ).height() > maxHeight ) {
            maxHeight = $( this ).height();
          }
        } );
        $( this ).find( '.program-info-wrapper' ).height( maxHeight );
      } );

      $( '.program-tabs__tab' ).on( 'toggleAfter', function( event ) {
        if ( window.easyToggleState.isActive( event.target ) ) {
          $( event.target ).attr( 'tabindex', 0 );
        } else {
          $( event.target ).attr( 'tabindex', -1 );
        }
      } );

      // Bind keyboard behaviors on the main accordion container
      $( document ).on( 'keydown', '.programs-tabs', function( event ) {
        const accordion = this;
        const triggers = Array.prototype.slice.call( accordion.querySelectorAll( '.program-tabs__tab' ) );
        const target = event.target;
        const key = event.which.toString();

        const isExpanded = target.getAttribute( 'aria-expanded' ) == 'true';

        // 33 = Page Up, 34 = Page Down
        const ctrlModifier = ( event.ctrlKey && key.match( /33|34/ ) );

        // Is this coming from an accordion header?
        if ( target.classList.contains( 'program-tabs__tab' ) ) {
          // Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
          // 37 = left, 39 = right
          if ( key.match( /37|39/ ) || ctrlModifier ) {
            const index = triggers.indexOf( target );
            const direction = ( key.match( /34|40/ ) ) ? 1 : -1;
            const length = triggers.length;
            const newIndex = ( index + length + direction ) % length;

            triggers[newIndex].focus();

            event.preventDefault();
          } else if ( key.match( /35|36/ ) ) {
            // 35 = End, 36 = Home keyboard operations
            switch ( key ) {
              // Go to first accordion
              case '36':
                triggers[0].focus();
                break;
                // Go to last accordion
              case '35':
                triggers[triggers.length - 1].focus();
                break;
            }
            event.preventDefault();
          }
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'programs-tabs', COMPONENT );
} )( app );
